{
  "categories": {
    "certificates": "Certificates",
    "dashboard": "Dashboard",
    "dataTransfer": "Data Transfer",
    "other": "Other",
    "products": "Products",
    "suppliers": "Suppliers"
  },
  "title": "FAQ"
}
